export const DsPaperDefaultProps = {
    elevation: 0
};
